export default __webpack_public_path__ + "static/media/ilac_mra.6a08aa68.svg";